// src/utils/StorageManager.js

class StorageManager {
  constructor() {
    this.consentKey = 'userConsentChoices';
  }

  saveConsent(choices) {
    const consentData = {
      necessary: true,
      session: choices?.session || false,
      functional: choices?.functional || false
    };
    localStorage.setItem(this.consentKey, JSON.stringify(consentData));
  }

  hasConsent(category) {
    try {
      const choices = JSON.parse(localStorage.getItem(this.consentKey));
      return choices?.[category] === true;
    } catch {
      return false;
    }
  }

  safeSetItem(key, value, category = 'necessary') {
    if (category === 'necessary' || this.hasConsent(category)) {
      localStorage.setItem(key, value);
      return true;
    }
    return false;
  }

  safeGetItem(key, category = 'necessary') {
    if (category === 'necessary' || this.hasConsent(category)) {
      return localStorage.getItem(key);
    }
    return null;
  }

  safeRemoveItem(key) {
    localStorage.removeItem(key);
  }

  clearAllData() {
    localStorage.clear();
    sessionStorage.clear();
  }
}

// Tworzymy i eksportujemy pojedynczą instancję
const storageManager = new StorageManager();
export default storageManager;